<template>
<div>
    <!-- ##### Breadcumb Area Start ##### -->
    <div class="breadcumb-area bg-img" :style="'background-image: url('+ require('@/assets/contact/contact.jpg') + ')'">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12 col-md-6">
                    <div class="breadcumb-text">
                        <!-- <h5>Say hello</h5> -->
                        <h2>Contáctanos</h2>
                        <p>
                            Así dijo Jehová: Paraos en los caminos, y mirad, y preguntad por las sendas antiguas, cuál sea el buen camino, y andad por él, y hallaréis descanso para vuestra alma. <br>
                            <b>Jeremías 6:16</b>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ##### Breadcumb Area End ##### -->


    <!-- ##### Contact Area Start ##### -->
    <section class="contact-area">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="contact-info-area">
                        <div class="row">
                            <!-- Contact Information -->
                            <div class="col-12 col-lg-6">
                                <div class="contact-information">
                                    <h5>Contáctanos</h5>
                                    <!-- Single Contact Area -->
                                    <div class="single-contact-area mb-30">
                                        <p>Dirección:</p>
                                        <span>631 E Adams Blvd, Los Angeles, <br>CA 90011, EE. UU. </span>
                                    </div>

                                    <!-- Single Contact Area -->
                                    <div class="single-contact-area mb-30">
                                        <p>Teléfono:</p>
                                        <span>+1 (626) 808-1237</span>
                                    </div>

                                    <!-- Single Contact Area -->
                                    <div class="single-contact-area mb-30">
                                        <p>Email:</p>
                                        <span>lasendaantigua.la@gmail.com</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Contact Form Area -->
                            <div class="col-12 col-lg-6">
                                <div class="contact-form-area">
                                    <h5>Envíanos un mensaje</h5>
                                    <form method="post" @submit.prevent="sendEmail()">
                                        <input type="text" class="form-control" v-model="name" placeholder="Nombre" required>
                                        <input type="email" class="form-control" v-model="email" placeholder="E-mail" required>                                        
                                        <textarea name="message" class="form-control" v-model="message" cols="30" rows="10" placeholder="Mensaje" required></textarea>
                                        <button class="btn faith-btn" type="submit">Contáctanos</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- ##### Contact Area End ##### -->

    <!-- ##### Google Maps ##### -->
    <div class="map-area">
        <div id="googleMap"></div>

        <!-- Google Maps -->
        <script type="application/javascript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBoh2idl84OpjUb9MREwHh4zVSrAJ0CVyc"></script>
        <script type="application/javascript" src="/js/google-map/map-active.js"></script>
    </div>

</div>
  
</template>


<script>

var Email = { send: function (a) { return new Promise(function (n, e) { a.nocache = Math.floor(1e6 * Math.random() + 1), a.Action = "Send"; var t = JSON.stringify(a); Email.ajaxPost("https://smtpjs.com/v3/smtpjs.aspx?", t, function (e) { n(e) }) }) }, ajaxPost: function (e, n, t) { var a = Email.createCORSRequest("POST", e); a.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), a.onload = function () { var e = a.responseText; null != t && t(e) }, a.send(n) }, ajax: function (e, n) { var t = Email.createCORSRequest("GET", e); t.onload = function () { var e = t.responseText; null != n && n(e) }, t.send() }, createCORSRequest: function (e, n) { var t = new XMLHttpRequest; return "withCredentials" in t ? t.open(e, n, !0) : "undefined" != typeof XDomainRequest ? (t = new XDomainRequest).open(e, n) : t = null, t } };

export default {
  data() {
    return {
      name: "",
      email: "",
      message: "",
    };
  },
  methods: {
    sendEmail() {
      try {

        const message = `
        SE RECIBIÓ UN MENSAJE NUEVO <br> <br>
        ${this.name} <br>
        ${this.email} <br> <br>
        ${this.message} <br>
        `

        Email.send({
            Host : "smtp.gmail.com",
            Username : "contactolasendaantigua@gmail.com",
            Password : "vFQdJRF47j88uJE",
            To : 'lasendaantigua.la@gmail.com;bernardomillie@gmail.com',
            // To : 'hugo2555@gmail.com',
            From : "contactolasendaantigua@gmail.com",
            Subject : "CONTACTO DESDE SITIO WEB",
            Body : message
        })

        this.email = "";
        this.name = "";
        this.message = "";

        this.$router.push("/contact/sent")
        
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcumb-area::after {
  background-color: none !important ;
}
</style>